import {capitalize} from 'lodash/string';
import request from './base';
import {excludeObjNullValue, camelToSnake} from 'utils/common';

export const fetchCurrentAccount = () => request.getJSON('/account/profile');

export const login = (payload) =>
  request.postJSON(
    '/account/login',
    excludeObjNullValue({
      identifier: payload.identifier,
      password: payload.password,
    }),
  );

export const logout = () => request.postJSON('/account/logout', null);

export const updateProfile = (payload) => {
  const formData = new FormData();
  const data = excludeObjNullValue({
    username: payload.username,
    first_name: capitalize(payload.firstName),
    last_name: capitalize(payload.lastName),
    password: payload.password,
    invitation_id: payload.invitationId,
    avatar: payload.avatar,
  });
  for (const [k, v] of Object.entries(data)) {
    formData.append(k, v);
  }
  return request.putForm('/account/profile', formData);
};

export const forgotPassword = (payload) =>
  request.postJSON(
    '/account/forgot-password',
    excludeObjNullValue({
      origin: window.location.origin,
      email: payload.email,
    }),
  );

export const resetForgotPassword = (payload) =>
  request.postJSON(
    `/account/forgot-password/reset${window.location.search}`,
    excludeObjNullValue({
      password: payload.password,
    }),
  );

export const readUserAgreement = () => request.postJSON(`/account/read-agreement`, {});

export const fetchAccountReadingNightsAchievedDate = (readingNights) =>
  request.getJSON('/account/reading-nights-achieved-date', camelToSnake({readingNights}));

export const switchActiveSchool = (schoolId) =>
  request.putJSON(
    `/account/switch-active-school`,
    excludeObjNullValue({
      school_id: schoolId,
    }),
  );

export const switchActiveClassroom = (classroomId) =>
  request.putJSON(
    `/account/switch-active-classroom`,
    excludeObjNullValue({
      classroom_id: classroomId,
    }),
  );
